import styled from 'styled-components';

export const ChatAreaContainer = styled.div<{
  $border?: string;
  $margin?: string;
  $borderRadius?: string;
}>`
  border: ${({ $border, theme }) => $border ?? `1px solid ${theme.color.chatBorder}`};
  border-radius: ${({ $borderRadius }) => $borderRadius ?? '0.5rem'};
  position: relative;
  background: ${({ theme }) => theme.color.chatBg};
  ${({ $margin }) => $margin && `margin: ${$margin};`}
`;
